import { render } from "./HomeView.vue?vue&type=template&id=8265c18e"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=8265c18e&lang=css"

import exportComponent from "D:\\webprojects\\220914order-buy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__